export default "__VITE_PUBLIC_ASSET__5acb6f17__"